<template>
  <!-- 薪酬查看  -->
  <div class="dashboard-container">
    <div class="app-container">
      <el-card shadow="never">
        <el-form class="demo-form-inline" label-position="right" label-width="100px">
          <el-row :gutter="2" style="width: 100%;">

            <el-col :span="6" v-if="types === '销售'">
              <el-form-item label="销售:">
                <!-- <el-input v-model="formState.teacherName" placeholder="请输入教师姓名" clearable></el-input> -->
                <el-select v-model="input1" style="width:100%;" placeholder="请选择销售" :filter-method="handleChangeName1">
                     <el-option v-for="item in optionsList1" :key="item.saleId" :label="item.label" :value="item.saleId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>


            <el-col :span="6" v-if="types === '销售'">
              <el-form-item label="销售类型:">
                <!-- <el-input v-model="formState.teacherName" placeholder="请输入教师姓名" clearable></el-input> -->
                <el-select v-model="input2" style="width:100%;" placeholder="请选择销售类型">
                    <el-option v-for="ele in input1List1" :key="ele.id" :label="ele.name" :value="ele.id" ></el-option>
                </el-select>
              </el-form-item>
            </el-col>


            <el-col :span="6" v-if="types === '规划师'">
              <el-form-item label="规划师:">
                <!-- <el-input v-model="formState.teacherName" placeholder="请输入教师姓名" clearable></el-input> -->
                <el-select v-model="input3" style="width:100%;" placeholder="请选择规划师">
                    <el-option v-for="ele in lePersList1" :key="ele.teacherId" :label="ele.teacherName" :value="ele.teacherId" ></el-option>
                </el-select>
              </el-form-item>
            </el-col>


            <el-col :span="6" >
              <el-form-item label="是否有效:">
                <!-- <el-input v-model="formState.teacherName" placeholder="请输入教师姓名" clearable></el-input> -->
                <el-select v-model="input4" style="width:100%;" placeholder="请选择是否有效">
                    <el-option v-for="ele in lePersList1111111" :key="ele.id" :label="ele.name" :value="ele.id" ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="6">
              <el-form-item label="状态:" prop="jobName">
                <el-select v-model="formState.basicClassNum" style="width:100%;" placeholder="请选择状态">
                    <el-option v-for="ele in lePersList" :key="ele.value" :label="ele.name" :value="ele.value" ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->

            <!-- <el-col :span="5">
              <el-form-item label="年:">
                <el-date-picker v-model="formState.salaryYear" type="year" value-format="yyyy" placeholder="选择年">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="月:" class="month_selection_box">
                <el-date-picker v-model="formState.salaryMonth" type="month" format="M月" value-format="MM"
                  popper-class="picker_month_select" placeholder="选择月份">
                </el-date-picker>
              </el-form-item>
            </el-col>
            -->
          </el-row>

          <div style="width: 100%;text-align: end;">
            <el-form-item>
                <!-- <el-button @click="countBottom" icon="el-icon-thumb" size="small" class="btns">一键下发</el-button> -->
                <!-- <el-button @click="count" icon="el-icon-thumb" size="small" class="btns">一键计算</el-button> -->
                <el-button @click="seachClear" class="btns" size="small" icon="el-icon-close">清除</el-button>
                <el-button type="primary" @click="seachRest" size="small" class="btns" icon="el-icon-search">搜索</el-button>
                <el-button type="primary" @click="seachRestAdd" size="small" class="btns" icon="el-icon-plus">新增</el-button>
                <!-- <el-button type="primary" @click="seachRest1" size="small" class="btns" icon="el-icon-search">导出</el-button> -->
            </el-form-item>
          </div>

        </el-form>

        <!--                     show-summary :summary-method="getSummaries"  :span-method="tableSpanMethod"  -->
        <el-table  ref="salaryTable" :summary-cell-style="{ 'text-align': 'center' }"   style="margin-top: 20px;width: 100%; " height="800" :data="salaryList"  border :highlight-current-row="true" :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}">
         
 
          <el-table-column v-if="types === '销售'" prop="saleName" show-overflow-tooltip  label="销售姓名" width=""></el-table-column>
          <el-table-column v-if="types === '销售'" prop="saleTypeStr" show-overflow-tooltip  label="销售类型" width=""></el-table-column>
          <el-table-column v-if="types === '销售'" prop="salary"  show-overflow-tooltip label="底薪" width=""></el-table-column>
          <el-table-column v-if="types === '销售'" prop="planeName"  show-overflow-tooltip label="提成方案" width=""></el-table-column>
          <el-table-column v-if="types === '销售'" prop="isDeleteStr"  show-overflow-tooltip label="有效无效" width=""></el-table-column>


          <el-table-column v-if="types === '规划师'" prop="teacherName" show-overflow-tooltip  label="规划师姓名" width=""></el-table-column>
          <el-table-column v-if="types === '规划师'" prop="salary" show-overflow-tooltip  label="底薪" width=""></el-table-column>
          <el-table-column v-if="types === '规划师'" prop="offlinePlaneName"  show-overflow-tooltip label="线下部分提成方案" width=""></el-table-column>
          <el-table-column v-if="types === '规划师'" prop="otherPlaneName"  show-overflow-tooltip label="规划丶纯补课部分提成方案" width=""></el-table-column>
          <el-table-column v-if="types === '规划师'" prop="isDeleteStr"  show-overflow-tooltip label="有效无效" width=""></el-table-column>
          

          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button @click="editInfo1(scope.row)" type="text">编辑</el-button>
              <!-- <el-button @click="editInfo1Coot(scope.row)" type="text">重新计算</el-button> -->
            </template>
          </el-table-column>
        </el-table>


        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="formState.pageNum" :page-size="formState.pageSize" layout="prev, pager, next,sizes, jumper"
          :total="totalNum">
        </el-pagination>
      </el-card>
      <salary-dialog ref="salaryMoudel" v-if="isShowDialog" :childTeacherId="parentTeacherId" :editOrview="editOrview"
        @isShowBtn="isShowBtn"></salary-dialog>

    </div>



    <el-card v-if="ShowCourseSalesStatisticsDetails" style="position: fixed;width: 100%;top: 70px; height: 100%;left: 0;z-index: 111;">
        <!-- <CourseSalesStatisticsDetails :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButs"></CourseSalesStatisticsDetails> -->

        <SalaryTypeDetails  stringType="线上销售薪酬" v-if="ShowCourseSalesStatisticsDetails" :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButs"></SalaryTypeDetails>
    </el-card>




    <el-dialog append-to-body :title="isShow ? '添加' : '修改'" :visible.sync="seachRestAddShow" width="60%" center :before-close="handleseachRestAddShow">
        <el-form v-if="types === '销售'">
          <el-form-item label="销售:">
            <el-select v-model="input_input1" style="width:100%;" placeholder="请选择销售" :filter-method="handleChangeName">
                <el-option v-for="item in optionsList111" :key="item.saleId" :label="item.label" :value="item.saleId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="销售类型:">
            <el-select v-model="input_input2" style="width:100%;" placeholder="请选择销售类型">
                <el-option v-for="ele in input1List1" :key="ele.id" :label="ele.name" :value="ele.id" ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="底薪" >
            <el-input placeholder="请输入底薪" v-model="input_input3"></el-input>
          </el-form-item>

          <el-form-item label="提成方案:">
            <el-select v-model="input_input4" style="width:100%;" placeholder="请选择提成方案">
                <el-option v-for="ele in lePersList111" :key="ele.id" :label="ele.name" :value="ele.id" ></el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="现金奖励方案:">
            <el-button type="primary" size="small" @click="handleAddTo(1)">添加现金奖励方案</el-button>
            <div v-if="list_input && list_input.length > 0" style="margin-top: 10px;">
              <el-tag v-for="(item, index) in list_input" :key="index"  style="margin-right: 5px;">
                {{ item.name }}
              </el-tag>
            </div>
          </el-form-item>

          <el-form-item label="底薪增幅方案:">
            <el-button type="primary" size="small"  @click="handleAddTo(2)">添加底薪增幅方案</el-button>
            <div v-if="list_input1 && list_input1.length > 0" style="margin-top: 10px;">
              <el-tag v-for="(item, index) in list_input1" :key="index"  style="margin-right: 5px;">
                {{ item.name }}
              </el-tag>
            </div>
          </el-form-item>

          <el-form-item label="底薪生效日期:" v-if="!isShow">
            <el-date-picker  v-model="input_input5"  type="month" style="width: 100%;"  value-format="yyyy-MM"   placeholder="选择日期">  </el-date-picker>
          </el-form-item>


          <el-form-item label="是否有效:"  v-if="!isShow">
            <el-select v-model="input_input6" style="width:100%;" placeholder="请选择是否有效">
                <el-option v-for="ele in lePersList1111111" :key="ele.id" :label="ele.name" :value="ele.id" ></el-option>
            </el-select>
          </el-form-item>

        </el-form>


        <el-form v-if="types === '规划师'">
          <el-form-item label="规划师:">
            <el-select v-model="input_input_input1" style="width:100%;" placeholder="请选择规划师">
                <el-option v-for="ele in optionsList11" :key="ele.id" :label="ele.realname" :value="ele.id" ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="底薪" >
            <el-input placeholder="请输入底薪" v-model="input_input_input2"></el-input>
          </el-form-item>

          <el-form-item label="线下提成方案:">
            <el-select v-model="input_input_input3" style="width:100%;" placeholder="请选择线下提成方案">
                <el-option v-for="ele in lePersList1111" :key="ele.id" :label="ele.name" :value="ele.id" ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="规划、纯补课提成方案:">
            <el-select v-model="input_input_input4" style="width:100%;" placeholder="请选择规划、纯补课提成方案">
                <el-option v-for="ele in lePersList11111" :key="ele.id" :label="ele.name" :value="ele.id" ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="底薪生效日期:" v-if="!isShow">
            <el-date-picker  v-model="input_input_input5"  type="month" style="width: 100%;"  value-format="yyyy-MM"   placeholder="选择日期">  </el-date-picker>
          </el-form-item>

          <el-form-item label="是否有效:"  v-if="!isShow">
            <el-select v-model="input_input_input6" style="width:100%;" placeholder="请选择是否有效">
                <el-option v-for="ele in lePersList1111111" :key="ele.id" :label="ele.name" :value="ele.id" ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="现金奖励方案:">
             <el-button type="primary" size="small" @click="handleAddTo(1)">添加现金奖励方案</el-button>
             <div v-if="list_input && list_input.length > 0" style="margin-top: 10px;">
               <el-tag v-for="(item, index) in list_input" :key="index"  style="margin-right: 5px;">
                 {{ item.name }}
               </el-tag>
             </div>
           </el-form-item>

           <el-form-item label="底薪增幅方案:">
             <el-button type="primary" size="small"  @click="handleAddTo(2)">添加底薪增幅方案</el-button>
             <div v-if="list_input1 && list_input1.length > 0" style="margin-top: 10px;">
               <el-tag v-for="(item, index) in list_input1" :key="index"  style="margin-right: 5px;">
                 {{ item.name }}
               </el-tag>
             </div>
           </el-form-item>

        </el-form>




        <span slot="footer" class="dialog-footer">
          <el-button @click="handleseachRestAddShow">取消</el-button>
          <el-button v-if="types === '销售'" type="primary" @click="handleseachRestAddShowSava">保存</el-button>
          <el-button v-if="types === '规划师'" type="primary" @click="handleseachRestAddShowSavas">保存</el-button>
        </span>
    </el-dialog>




    <el-dialog append-to-body :visible.sync="handle_isShowDialog" width="40%" center :before-close="handle_isShowDialogclose">
       <div style="display: flex;flex-wrap: wrap;" v-if="types_is === 1">
          <el-checkbox-group v-model="selectedCashRewardIds" style="display:flex;flex-wrap:wrap;">
            <div v-for="(item, index) in lePersList111111" :key="item.id" style="margin-left: 10px;  margin-bottom: 20px;  border: 1px solid #e1dcdc; padding: 10px; border-radius: 10px;">
              <el-checkbox :label="item.id" @change="handleChangecheckbox(item,index,$event)">
                <h3 style="margin-top: 0px">{{ item.name }}</h3>
                <div style="margin-top: 0px" v-if="item.startDate && item.endDate">有效期:{{ item.startDate }} - {{ item.endDate }}</div>
              </el-checkbox>
            </div>
          </el-checkbox-group>
       </div>
       <div style="display: flex;flex-wrap: wrap;" v-if="types_is === 2">
          <el-checkbox-group v-model="selectedSalaryIncreaseIds" style="display:flex;flex-wrap:wrap;">
            <div v-for="(item, index) in lePersList111111111" :key="item.id" style="margin-left: 10px;  margin-bottom: 20px;  border: 1px solid #e1dcdc; padding: 10px; border-radius: 10px;">
              <el-checkbox :label="item.id" @change="handleChangecheckbox(item,index,$event)">
                <h3 style="margin-top: 0px">{{ item.name }}</h3>
                <div style="margin-top: 0px" v-if="item.startDate && item.endDate">有效期:{{ item.startDate }} - {{ item.endDate }}</div>
              </el-checkbox>
            </div>
          </el-checkbox-group>
       </div>
       <span slot="footer" class="dialog-footer">
          <el-button @click="handle_isShowDialogclose">取 消</el-button>
          <el-button type="primary" @click="handlecenterDialogVisible1">确 定</el-button>
       </span>
    </el-dialog>


    <el-dialog  title="有效期" :visible="centerDialogVisible"  width="40%"  center :before-close="handlecenterDialogVisiblecCle1">
        <el-date-picker v-if="centerDialogVisible" style="width: 100%;"  value-format="yyyy-MM" v-model="time" type="monthrange"  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handlecenterDialogVisiblecCle1">取 消</el-button>
          <el-button type="primary" @click="handlecenterDialogVisible">确 定</el-button>
        </span>
    </el-dialog>




  </div>
</template>
<script>
import apiBaseUrl from "../../config/api";
import salaryDialog from "./salaryEdit.vue"
import CourseSalesStatisticsDetails from "./CourseSalesStatisticsDetails.vue"
import SalaryTypeDetails from "./SalaryTypeDetails_copy.vue"
import axios from "axios";
import { getgetListCount, getListSalaryssNew, getListSalarysNew } from "@/api/salaryapi"


 // 获取当前日期
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // 月份从0开始

    // 补零函数
    function pad(n) {
      return n < 10 ? '0' + n : n;
    }

    // 当前月第一天
    const firstDay = `${year}-${pad(month)}-01`;
    // 当前月最后一天
    const lastDay = new Date(year, month, 0).getDate();
    const currentDay = `${year}-${pad(month)}-${pad(lastDay)}`;

export default {
  components: {
    salaryDialog,
    CourseSalesStatisticsDetails,
    SalaryTypeDetails,
  },
  props: {
    types: {
      type: String,
      default: ''
    },
  },
  data () {
    return {

      handle_isShowDialog:false,
      centerDialogVisible:false,

      

      list_input:[],
      list_input1:[],

      input_input1 :'',
      input_input2 :'',
      input_input3 :'',
      input_input4 :'',
      input_input5 :'',
      input_input6 :'',


      input_input4444:'',
      input_input4444444:'',

      input_input_input1 :'',
      input_input_input2 :'',
      input_input_input3 :'',
      input_input_input4 :'',
      input_input_input5 :'',
      input_input_input6 :'',


      lePersList111111:[],
      lePersList111111111:[],

      // 选中项 id 列表（用于 checkbox-group 的 v-model）
      selectedCashRewardIds: [],
      selectedSalaryIncreaseIds: [],


      input1 :'',
      input2 :'',
      input3 :'',

      input1List1:[ 
        { id: 1, name: "线上销售" }, 
        { id: 2, name: "线下销售" },
      ],

      lePersList111:[],


      planNames:'',
      dateTimeLists:'',
      isShowDialog: false,
      editOrview: true,
      formState: {
        pageNum: 1,
        pageSize: 10,
        teacherName: "",
        salaryYear: "",
        salaryMonth: "",
        basicClassNum: "",
      },
      totalNum: 0,
      salaryList: [],
      parentTeacherId: "",
      ShowCourseSalesStatisticsDetails:false,
      TimeList:[ firstDay, currentDay ],
      DetailsRow:{},

      lePersList: [
        // { name: "在职", value: 1 },
        // { name: "离职", value: 2 },
        // { name: "请假", value: 3 },
        // { name: "休假", value: 4 },


        { name: "未确认", value: 0 },
        { name: "已确认", value: 1 },
        // { name: "复核中", value: 3 },
      ],

      lePersList1111111:[
        { id: 0, name: "有效", },
        { id: 1, name: "无效", },
      ],

      lePersList1:[],
      optionsList1:[],

      summaryData: {
        actualWages: 0, 
        performance: 0, 
        monthSalary:0,
        payableWages:0,
        commission:0,
        subsidy:0,
        socialSecurity:0,
        monthRefund:0,
        reward:0,
        validAmount:0,
        deduction:0,
        performanceAmount:0,
        notReachAmount:0,
        refundCommission:0,
        totalCommission:0, 
        renewalAmount:0,
        classSalesAmount:0,
        classSalesCommission:0,
        renewalCommission:0
      },

      seachRestAddShow:false,
      isShow:'',


      optionsList111:[],

      lePersList1111:[],
      lePersList11111:[],

      input4:'',

      types_is:'',

      time:[],

      cashRewardPlanList:[],
      salaryIncreasePlaneList:[],

      index: '',

    }
  },
  created () {
    
  },

  mounted () {
    this.optionsList1 = JSON.parse(sessionStorage.getItem('customersaleObj1'))
    this.optionsList111 = JSON.parse(sessionStorage.getItem('customersaleObj1'))
    this.lePersList1 = JSON.parse(sessionStorage.getItem('projectTeacherFindList'))

    this.getListinit();
    this.handleInitToAll()
  },

  methods: {

    handleChangeName(value) {
      if (value) {
        axios.post(`${apiBaseUrl}/saleWeight/getSaleList`, { saleName: value },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          if (res.data.code == 200) {
            let datas = res.data.data.map(fore => {
                fore.id = fore.telephone
                fore.saleId = fore.saleId
                fore.label = fore.saleName 
                return fore
            })
            this.optionsList111 = datas
          }else{
            this.optionsList111 = JSON.parse(sessionStorage.getItem('customersaleObj1'))
          }
        })
      } else {
        this.optionsList111 = JSON.parse(sessionStorage.getItem('customersaleObj1'))
      }
    },

    handleChangeName1(value) {
      if (value) {
        axios.post(`${apiBaseUrl}/saleWeight/getSaleList`, { saleName: value },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          if (res.data.code == 200) {
            let datas = res.data.data.map(fore => {
                fore.id = fore.telephone
                fore.saleId = fore.saleId
                fore.label = fore.saleName 
                return fore
            })
            this.optionsList1 = datas
          }else{
            this.optionsList1 = JSON.parse(sessionStorage.getItem('customersaleObj1'))
          }
        })
      } else {
        this.optionsList1 = JSON.parse(sessionStorage.getItem('customersaleObj1'))
      }
    },

    handleChangecheckbox(itme,index,e){
      if(e){
        this.typeTimeis = true
        this.typeTimeis1 = false
        this.index = index
        // 如果该选项已经有生效时间，映射到时间选择器上，便于编辑
        if(itme && (itme.startDate || itme.endDate)){
          this.time = [itme.startDate || '', itme.endDate || '']
        }else{
          this.time = []
        }
        this.centerDialogVisible = true
      }
    },

    

    handle_isShowDialogclose(){
      this.handle_isShowDialog = false
      
      axios.get(`${apiBaseUrl}/rewardPlane/getCashRewardPlane/${ this.types === '销售' ? 1 : this.types === '规划师' ? 2 : '' } `, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
         let datas = res.data.data
         if (res.data.code == 200) {
            this.lePersList111111 = datas && datas.length > 0 ? datas.map(item => {
              item.startDate = ''
              item.endDate = ''
              return item
            }) : []
         }else{
          this.lePersList111111 = []
         }
      }).catch((error) => {
        this.lePersList111111 = []
      })


      axios.get(`${apiBaseUrl}/salaryIncreasePlane/getSalaryIncreasePlane/${ this.types === '销售' ? 1 : this.types === '规划师' ? 2 : '' } `, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
         let datas = res.data.data
         if (res.data.code == 200) {
            this.lePersList111111111 = datas && datas.length > 0 ? datas.map(item => {
              item.startDate = ''
              item.endDate = ''
              return item
            }) : []
         }else{
          this.lePersList111111111 = []
         }
      }).catch((error) => {
        this.lePersList111111111 = []
      })
    },

    handleAddTo(type){
      this.handle_isShowDialog = true
      this.types_is = type

      axios.get(`${apiBaseUrl}/rewardPlane/getCashRewardPlane/${ this.types === '销售' ? 1 : this.types === '规划师' ? 2 : '' } `, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
         let datas = res.data.data
         if (res.data.code == 200) {
            this.lePersList111111 = datas && datas.length > 0 ? datas.map(item => {
              item.startDate = ''
              item.endDate = ''
              return item
            }) : []

            // 如果已有选中项（来自编辑），自动勾选对应 id
            if (this.list_input && this.list_input.length > 0) {
              const ids = this.list_input.map(it => it.planeId || it.id || it.planId).filter(Boolean)
              this.selectedCashRewardIds = ids

              // 将 list_input 中的开始/结束时间映射回选项数组，便于在弹窗中展示
              this.lePersList111111 = this.lePersList111111.map(opt => {
                const match = this.list_input.find(li => (li.planeId || li.id || li.planId) == opt.id)
                if (match) {
                  opt.startDate = match.startDate || match.effectiveStartDate || match.effectiveDate || ''
                  opt.endDate = match.endDate || match.effectiveEndDate || match.effectiveDate || ''
                }
                return opt
              })
            }
         }else{
          this.lePersList111111 = []
         }
      }).catch((error) => {
        this.lePersList111111 = []
      })


      axios.get(`${apiBaseUrl}/salaryIncreasePlane/getSalaryIncreasePlane/${ this.types === '销售' ? 1 : this.types === '规划师' ? 2 : '' } `, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
         let datas = res.data.data
         if (res.data.code == 200) {
            this.lePersList111111111 = datas && datas.length > 0 ? datas.map(item => {
              item.startDate = ''
              item.endDate = ''
              return item
            }) : []

            // 如果已有选中项（来自编辑），自动勾选对应 id
            if (this.list_input1 && this.list_input1.length > 0) {
              const ids = this.list_input1.map(it => it.planeId || it.id || it.planId).filter(Boolean)
              this.selectedSalaryIncreaseIds = ids

              // 将 list_input1 中的开始/结束时间映射回选项数组，便于在弹窗中展示
              this.lePersList111111111 = this.lePersList111111111.map(opt => {
                const match = this.list_input1.find(li => (li.planeId || li.id || li.planId) == opt.id)
                if (match) {
                  opt.startDate = match.startDate || match.effectiveStartDate || match.effectiveDate || ''
                  opt.endDate = match.endDate || match.effectiveEndDate || match.effectiveDate || ''
                }
                return opt
              })
            }
         }else{
          this.lePersList111111111 = []
         }
      }).catch((error) => {
        this.lePersList111111111 = []
      })
    },

    handlecenterDialogVisiblecCle1() {
      this.time = []
      this.centerDialogVisible = false
    },

    handlecenterDialogVisible1(){
      if(this.types_is === 1){
            this.handle_isShowDialog = false
            this.list_input = this.lePersList111111.filter(item => this.selectedCashRewardIds.includes(item.id))
            this.cashRewardPlanList = this.list_input.map((item, index) => {
              item.serialNum = index + 1
              item.planeId = item.id
              return item
            })
        }

        if(this.types_is === 2){
          this.handle_isShowDialog = false
          this.list_input1 = this.lePersList111111111.filter(item => this.selectedSalaryIncreaseIds.includes(item.id))
          this.salaryIncreasePlaneList = this.list_input1.map((item, index) => {
              item.serialNum = index + 1
              item.planeId = item.id
              return item
          })
        }
    },

    handlecenterDialogVisible(){

        if(this.types_is === 1){

            if(this.index >= 0 && this.index < this.lePersList111111.length) {
                this.lePersList111111[this.index].startDate = this.time[0]
                this.lePersList111111[this.index].endDate = this.time[1]
            }

            this.time = []
            this.centerDialogVisible = false
        }

        if(this.types_is === 2){

            if(this.index >= 0 && this.index < this.lePersList111111111.length) {
                this.lePersList111111111[this.index].startDate = this.time[0]
                this.lePersList111111111[this.index].endDate = this.time[1]
            }


            this.time = []
            this.centerDialogVisible = false
        }

        console.log(this.lePersList111111)
    },

    handleInitToAll(){

      axios.get(`${apiBaseUrl}/rewardPlane/getCashRewardPlane/${ this.types === '销售' ? 1 : this.types === '规划师' ? 2 : '' } `, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
         let datas = res.data.data
         if (res.data.code == 200) {
            this.lePersList111111 = datas && datas.length > 0 ? datas.map(item => {
              item.startDate = ''
              item.endDate = ''
              return item
            }) : []
         }else{
          this.lePersList111111 = []
         }
      }).catch((error) => {
        this.lePersList111111 = []
      })


      axios.get(`${apiBaseUrl}/salaryIncreasePlane/getSalaryIncreasePlane/${ this.types === '销售' ? 1 : this.types === '规划师' ? 2 : '' } `, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
         let datas = res.data.data
         if (res.data.code == 200) {
            this.lePersList111111111 = datas && datas.length > 0 ? datas.map(item => {
              item.startDate = ''
              item.endDate = ''
              return item
            }) : []
         }else{
          this.lePersList111111111 = []
         }
      }).catch((error) => {
        this.lePersList111111111 = []
      })

      axios.get(`${apiBaseUrl}/teacher/teacherList `, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
         let datas = res.data.data
         if (res.data.code == 200) {
            this.optionsList11 = datas
         }else{
          this.optionsList11 = []
         }
      }).catch((error) => {
        this.optionsList11 = []
      })

      axios.get(`${apiBaseUrl}/commissionPlan/getPlane/${ this.types === '销售' ? 1 : this.types === '规划师' ? 2 : '' } `, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
         let datas = res.data.data
         if (res.data.code == 200) {
            this.lePersList111 = datas
         }else{
          this.lePersList111 = []
         }
      }).catch((error) => {
        this.lePersList111 = []
      })

      axios.get(`${apiBaseUrl}/commissionPlan/getPlane/${ this.types === '销售' ? 1 : this.types === '规划师' ? 2 : '' } `, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
         let datas = res.data.data
         if (res.data.code == 200) {
            this.lePersList1111 = datas
         }else{
          this.lePersList1111 = []
         }
      }).catch((error) => {
        this.lePersList1111 = []
      })

      axios.get(`${apiBaseUrl}/commissionPlan/getPlane/${ this.types === '销售' ? 1 : this.types === '规划师' ? 2 : '' } `, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
         let datas = res.data.data
         if (res.data.code == 200) {
            this.lePersList11111 = datas
         }else{
          this.lePersList11111 = []
         }
      }).catch((error) => {
        this.lePersList11111 = []
      })

    },


    getListinit () {
      let obj = {  url: '',  data: {} }
      if(this.types === '销售'){
        obj.url = '/sale/querySaleList'
        obj.data = {
          pageNo: this.formState.pageNum,
          pageSize: this.formState.pageSize,
          saleType: this.input2 ? this.input2 : '',
          saleId: this.input1 ? this.input1 : '',
          isDelete: this.input4,
        }
      }

      if(this.types === '规划师'){
        obj.url = '/projectTeacher/queryTeacherList'
        obj.data = {
          pageNo: this.formState.pageNum,
          pageSize: this.formState.pageSize,
          teacherId: this.input3 ? this.input3 : '',
          isDelete: this.input4,
        }
      }


      axios.post(`${apiBaseUrl}${obj.url}`, obj.data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        console.log(res.data.data)
        if (res.data.code == 200) {
            let datas = res.data.data
            this.salaryList = datas.records
            this.totalNum = datas.total
            this.$message.success(res.data.message)
        } else {
          this.salaryList = []
          this.totalNum = 0
        }
      }).catch((error) => {
        console.error(error);
         this.totalNum = 0
         this.salaryList = []
         this.$message.error(error)
      });


    },

    handleseachRestAddShow(){
      this.isShow = ''
      this.seachRestAddShow = false

      this.list_input = []
      this.list_input1 = []

      this.selectedCashRewardIds = []
      this.selectedSalaryIncreaseIds = []

      this.input_input1 = ''
      this.input_input2 = ''
      this.input_input3 = ''
      this.input_input4 = ''
      this.input_input5 = ''
      this.input_input6 = ''

      this.input_input4444 = ''
      this.input_input4444444 = ''

      this.input_input_input1 = ''
      this.input_input_input2 = ''
      this.input_input_input3 = ''
      this.input_input_input4 = ''
      this.input_input_input5 = ''
      this.input_input_input6 = ''

      this.handle_isShowDialogclose()
    },


    handleseachRestAddShowSava(){
      let obj = {  url: '',  data: {} }

      if(this.types === '销售' && this.isShow){
        obj.url = '/sale/addSale'
        obj.data = {
          saleId: this.input_input1 ,
          saleType: this.input_input2 ,
          salary: this.input_input3 ,
          planeId: this.input_input4 ,

          cashRewardPlanList:this.cashRewardPlanList,
          salaryIncreasePlaneList:this.salaryIncreasePlaneList,
        }
        this.handleseachRestAddShowSava1(obj)
      }else{
        obj.url = '/sale/updateSale'
        obj.data = {
          id: this.DetailsRow.id,
          saleId: this.input_input1,
          saleType: this.input_input2 ,
          salary: this.input_input3 ,
          planeId: this.input_input4 ,
          effectiveDate: this.input_input5 ,
          isDelete: this.input_input6,
          
          cashRewardPlanList:this.cashRewardPlanList,
          salaryIncreasePlaneList:this.salaryIncreasePlaneList,
        }
        this.handleseachRestAddShowSava1(obj)
      }
 


      
    },


    handleseachRestAddShowSavas(){
      let obj = {  url: '',  data: {} }
      
      if(this.types === '规划师' && this.isShow){
        obj.url = '/projectTeacher/addProjectTeacher'
        obj.data = {
          teacherId: this.input_input_input1 ,
          salary: this.input_input_input2 ,
          offlinePlaneId: this.input_input_input3 ,
          otherPlaneId: this.input_input_input4,

          cashRewardPlanList:this.cashRewardPlanList,
          salaryIncreasePlaneList:this.salaryIncreasePlaneList,
        }
        this.handleseachRestAddShowSava1(obj)
      }else{
        obj.url = '/projectTeacher/updateProjectTeacher'
        obj.data = {
          id: this.DetailsRow.id,
          teacherId: this.input_input_input1,
          salary: this.input_input_input2 ,
          offlinePlaneId: this.input_input_input3 ,
          otherPlaneId: this.input_input_input4 ,
          effectiveDate: this.input_input_input5 ,
          isDelete: this.input_input_input6,

          cashRewardPlanList:this.cashRewardPlanList,
          salaryIncreasePlaneList:this.salaryIncreasePlaneList,
        }
        this.handleseachRestAddShowSava1(obj)
      }


      
    },

    handleseachRestAddShowSava1(obj){
      axios.post(`${apiBaseUrl}${obj.url}`, obj.data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        let datas = res.data
        if (datas.code == 200) {
            this.$message.success(datas.message)
            this.isShow = ''
            this.seachRestAddShow = false
            this.getListinit()
        } else {
          this.$message.error(datas.message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },

    seachRestAdd(){
      this.isShow = '添加'
      this.seachRestAddShow = true
    },

     // 合计行内容
    getSummaries({ columns, data }) {
        const sums = [];
        columns.forEach((column, index) => {
          // 前3列不展示
          if (index === 1) {
            sums[index] = '汇总';
          } 
          else if (column.property && this.summaryData[column.property] !== undefined) {
            sums[index] = this.summaryData[column.property];
          } else if (data.length === 0 && index >= 2) {
            // 没有数据时也展示“总计：”
            sums[index] = '';
          } else {
            sums[index] = '';
          }
        });
        return sums;
    },
    // 合并前3列
    tableSpanMethod({ rowIndex, columnIndex }) {
      // 最后一行（合计行）合并前3列
      if (rowIndex === this.salaryList.length && columnIndex === 0) {
        return [1, 4]; // 合并1行3列
      }
      if (rowIndex === this.salaryList.length && (columnIndex === 1 || columnIndex === 2)) {
        return [0, 0]; // 被合并的单元格
      }
    },



    handleEmitButs  (event) {
        this.ShowCourseSalesStatisticsDetails = event
    },

    count () {
      let data = {
        salaryYear: this.formState.salaryYear,
        salaryMonth: this.formState.salaryMonth
      }
      axios
        .post(`${apiBaseUrl}/salary/calculate`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            // this.$message.success(res.data.message)
            this.getList()
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getList () {
      let data = {
        pageNo: this.formState.pageNum,
        pageSize: this.formState.pageSize,
        projectTeacherId: this.formState.teacherName ? this.formState.teacherName : '',
        // state: this.formState.basicClassNum ? this.formState.basicClassNum : '',
        yearStr: this.formState.salaryYear ? this.formState.salaryYear : '',
        monthStr: this.formState.salaryMonth ? this.formState.salaryMonth : '',
      } 

      getListSalarysNew(data).then((res) => {
        if (res.code == 200) {
            this.salaryList = res.data.records
            this.totalNum = res.data.total
            // this.formState.pageNum = res.data.current
        } else {
          this.salaryList = []
          this.totalNum = 0
        }
       
      }).catch((error) => {
        console.error(error);
         this.salaryList = []
         this.totalNum = 0
         this.$message.error(error)
      });



      getListSalaryssNew(data).then((res) => {
        if (res.code == 200) {
          this.summaryData = {
            actualWages: res.data.actualSalarySum,
            performance: res.data.performanceSum,
            monthSalary: res.data.salarySum,
            payableWages: res.data.totalSalarySum,
            commission: res.data.commissionSum,
            subsidy: res.data.subsidySum,
            socialSecurity: res.data.socialSecuritySum,
            monthRefund: res.data.refundSum,
            reward: res.data.rewardSum,
            validAmount: res.data.amountSum,
            deduction: res.data.deductionSum,
            performanceAmount: res.data.performanceAmountSum, 
            notReachAmount: res.data.notReachAmountSum,
            refundCommission: res.data.refundCommissionSum,
            totalCommission: res.data. totalCommissionSum, 
            renewalAmount: res.data.renewalAmountSum,
            classSalesAmount: res.data.classSalesAmountSum,
            classSalesCommission: res.data.classSalesCommissionSum,
            renewalCommission: res.data.renewalCommissionSum,
            
          }; 
        } else {
          this.summaryData = {
              renewalCommission:0,
              classSalesCommission:0,
              classSalesAmount:0,
              actualWages: 0, 
              renewalAmount: 0,
              performance: 0, 
              monthSalary:0,
              payableWages:0,
              commission:0,
              subsidy:0,
              socialSecurity:0,
              monthRefund:0,
              reward:0,
              validAmount:0,
              deduction:0,
              performanceAmount:0,
              notReachAmount:0,
              refundCommission:0,
              totalCommission:0, 
          };
        }

         this.$nextTick(() => {
            if (this.$refs.salaryTable) {
              this.$refs.salaryTable.doLayout();
            }
         });

      }).catch((error) => {
        this.summaryData = {
            actualWages: 0, 
            performance: 0, 
            monthSalary:0,
            payableWages:0,
            commission:0,
            subsidy:0,
            socialSecurity:0,
            monthRefund:0,
            reward:0,
            validAmount:0,
            deduction:0,
            performanceAmount:0,
            notReachAmount:0,
            refundCommission:0,
            totalCommission:0, 
        };
        this.$message.error(error)
      });


    },
    seachRest1(){
      let data = {  teacherName: this.formState.teacherName ? this.formState.teacherName : '', salaryYear: this.formState.salaryYear ? this.formState.salaryYear : '',  salaryMonth: this.formState.salaryMonth ? this.formState.salaryMonth : '', }
      axios.post(`${apiBaseUrl}//salary/exportTeacherSalary`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
         if(response.status == 200){
             const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
             const downloadLink = document.createElement("a");
             downloadLink.href = URL.createObjectURL(blob);
             downloadLink.download = "薪酬模板.xlsx";
             downloadLink.click();
             this.$message.success('导出成功')
         }
         else{
            this.$message.error("上传文件类型只能是 .png, .jpg, .pdf 格式!");
         }
      })
    },

    countBottom(){
      let data = { 
        salaryYear: this.formState.salaryYear,     //年 yyyy格式
        salaryMonth: this.formState.salaryMonth,       //月 MM格式 
      }
      axios.post(`${apiBaseUrl}/salaryPlan/salaryIssue`, data, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
         if(response.status == 200){
             this.$message.success('发放成功')
         }else{
            this.$message.error("发放失败!");
         }
      }).catch((error) => {
        this.$message.error(error)
      })
    },

    editInfo1Coot(row){
      axios.get(`${apiBaseUrl}/salaryPlan/salaryAnew?id=${row.id}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}) .then((res) => {
        if (res.data.code == 200) {
          //  this.$message.success(res.data.message)
        }else{
          this.$message.error(res.data.message)
        }
      }).catch((error) => {
        this.$message.error(error)
      });
    },


    editInfo1(row, val){
        
        this.DetailsRow = row

        this.input_input1 = row.saleId
        this.input_input2 = row.saleType
        this.input_input3 = row.salary
        this.input_input4 = row.planeId
        this.input_input5 = row.effectiveDate
        this.input_input6 = row.isDelete

        this.input_input_input1 = row.teacherId
        this.input_input_input2 = row.salary
        this.input_input_input3 = row.offlinePlaneId
        this.input_input_input4 = row.otherPlaneId
        this.input_input_input5 = row.effectiveDate 
        this.input_input_input6 = row.isDelete
        
        

        this.isShow = ''
        this.seachRestAddShow = true


        this.list_input = row.cashRewardPlanList && row.cashRewardPlanList.length > 0 ? row.cashRewardPlanList.map((item, index) => {
              item.name = item.planeName
              return item
        }) : []
        
        this.list_input1 = row.salaryIncreasePlaneList && row.salaryIncreasePlaneList.length > 0 ? row.salaryIncreasePlaneList.map((item, index) => {
              item.name = item.planeName
              return item
        }) : []

        // this.ShowCourseSalesStatisticsDetails = true
    },
    editInfo (row, val) {
      // this.isShowDialog = false
      if (val == "查看") {
        this.editOrview = false
      } else {
        this.editOrview = true
      }
      console.log(row);
      this.isShowDialog = true
      this.parentTeacherId = row.id
      // this.$refs.salaryMoudel.openDialogChild()

    },
    seachClear () {
      this.input1 = ''
      this.input2 = ''
      this.input3 = ''
      this.input4 = ''

      this.formState = {
        pageNum: 1,
        pageSize: 10,
        teacherName: "", 
        salaryYear: "",
        salaryMonth: "",
        basicClassNum: "",
      }
      this.getListinit()
    },
    seachRest () {
      console.log(this.formState);
      this.getListinit()
    },
    handleSizeChange (pageSize) {
      this.formState.pageSize = pageSize;
      this.getListinit();
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.formState.pageNum = newPage;
      this.getListinit();
    },
    isShowBtn () {
      this.isShowDialog = false
    },
  }

};
</script>

<style scoped lang="less">
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 7px;
  vertical-align: top;
  margin-bottom: 19px;
}


// ::v-deep.el-form-item__label {
//   text-align: right;
//   vertical-align: middle;
//   float: left;
//   font-size: 14px;
//   color: #606266;
//   line-height: 40px;
//   padding: 0 5px 0 0 !important;
//   box-sizing: border-box;
// }


/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  // #aa>>>.el-dialog {
  //   width: 70% !important;
  // }
}
 .btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}

/deep/  .is-leaf{
  text-align: center !important;
}

/deep/ .el-table__cell{
    text-align: center !important;
}

</style>



// WEBPACK FOOTER //
// src/SalescompensationAll/BaseSalaryPlanType.vue